/**
 * This function is used to return a backwards compatible purchase motion.
 * It accepts a string and returns a SCREAMING_SNAKE_CASE purchase motion if a match is found.
 */
export function normalizePurchaseMotion(purchaseMotion) {
  switch (purchaseMotion) {
    case 'assignSeat':
      return 'ASSIGN_SEAT';
    case 'buyTouchless':
      return 'BUY_TOUCHLESS';
    case 'buyAdditionalSeats':
      return 'BUY_ADDITIONAL_SEATS';
    case 'buyAdditionalContacts':
      return 'BUY_ADDITIONAL_CONTACTS';
    case 'pricingPageRedirect':
      return 'PRICING_PAGE_REDIRECT';
    case 'requestAccess':
      return 'REQUEST_ACCESS';
    case 'requestSeat':
      return 'REQUEST_SEAT';
    case 'talkToSales':
      return 'TALK_TO_SALES';
    case 'talkToSalesFallback':
      return 'TALK_TO_SALES_FALLBACK';
    case 'trial':
      return 'TRIAL';
    case 'viewAccount':
      return 'VIEW_ACCOUNT';
    default:
      return purchaseMotion;
  }
}